import { TrainStatusMnemonicEnum } from '@constants/apiEnums';

export enum EAppRouteGroup {
  GroupInputScheme = 'scheme',
  GroupSchedules = 'schedules',
  GroupWagonGroups = 'wagon-groups',
  LocomotivesArea = 'locomotive-area',
  TrainInfo = 'train-info',
}
export enum EAppRouteStatus {
  StatusPlanning = 'planning',
  StatusApproval = 'approval',
  StatusApproved = 'approved',
}

export const TRAIN_STATUS_NAMES: Readonly<Record<string, string>> =
  Object.freeze({
    [EAppRouteStatus.StatusPlanning]: TrainStatusMnemonicEnum.planning,
    [EAppRouteStatus.StatusApproval]: TrainStatusMnemonicEnum.approval,
    [EAppRouteStatus.StatusApproved]: TrainStatusMnemonicEnum.approved,
  });

export function mapperStatusValue(
  status: TrainStatusMnemonicEnum,
): EAppRouteStatus {
  switch (status) {
    case TrainStatusMnemonicEnum.planning:
      return EAppRouteStatus.StatusPlanning;

    case TrainStatusMnemonicEnum.approval:
    case TrainStatusMnemonicEnum.preApproved:
      return EAppRouteStatus.StatusApproval;

    case TrainStatusMnemonicEnum.approved:
      return EAppRouteStatus.StatusApproved;
  }
}
